/* eslint-disable */
const cache = {}
const cacheTimer = {}

function valid(...path) {
  var isValid = true
  var isValidTime = true

  var nowMilliseconds = Date.now()
  const { item, validUntil } = traverseHelper(path, (curr, currPath, stop) => {
    stop()
    isValid = false
  })
  if (validUntil == undefined || nowMilliseconds > validUntil) {
    isValidTime = false
  }

  return isValid && isValidTime
}

function get(...path) {
  const { item, validUntil } = traverseHelper(path, (curr, currPath, stop) => {
    stop()
  })

  return item
}

function set(data, timeValid, ...path) {
  var nowMilliseconds = Date.now()
  if (path.length === 1) {
    cache[path[0]] = data
    cacheTimer[path[0]] = nowMilliseconds
    return
  }

  const { item, validUntil } = traverseHelper(path.slice(0, path.length - 1), (curr, currPath, stop) => {
    curr[currPath] = {}
  })

  item[path[path.length - 1]] = data
  validUntil[path[path.length - 1]] = nowMilliseconds + timeValid
}

function traverseHelper(path, callback) {
  var exitFunc = false
  function stop() {
    exitFunc = true
  }

  var curr = cache
  var currTimer = cacheTimer
  for (const currPath of path) {
    if (!curr.hasOwnProperty(currPath)) {
      callback(curr, currPath, stop)
      callback(currTimer, currPath, stop)
    }
    if (exitFunc) {
      return {
        item: null,
        validUntil: null,
      }
    }
    curr = curr[currPath]
    currTimer = currTimer[currPath]
  }

  return {
    item: curr,
    validUntil: currTimer,
  }
}

function checkGetMiss(cachePath, cacheMissCallback) {
  if (valid(...cachePath)) {
    return Promise.resolve(get(...cachePath))
  }

  return cacheMissCallback()
}

export default {
  valid,
  get,
  set,
  checkGetMiss,
}
